import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { TitleComponent } from '@connect-services/client/components/field-intervention-title/title/title.component';
import { DetailPanelService, PanelAction } from '@connect-services/client/services/detail-panel.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule, RouterOutlet, TitleComponent],
    selector: 'app-detail-panel',
    styleUrl: './detail-panel.component.scss',
    templateUrl: './detail-panel.component.html',
})
export class DetailPanelComponent {
    protected readonly actions = computed<PanelAction[]>(() => this.detailPanelService.actions());
    protected readonly hasDeleteAction = computed<boolean>(() => {
        return this.detailPanelService
            .actions()
            .some((action: PanelAction) => action.type === ButtonType.ALERT_SECONDARY);
    });
    protected readonly title = computed(() => this.detailPanelService.title());

    private readonly detailPanelService = inject(DetailPanelService);
    private readonly router = inject(Router);

    public onDetailClose(): void {
        void this.router.navigate(this.detailPanelService.navigateTo());
    }
}
